import styled from "styled-components";

export const LangaugeStyleWrapper = styled.div`
  .btn{
    border-radius: 50%;
    padding: 0.5rem;
    background: #fff;
  }
 @media only screen and (max-width: 767px) {

 }
`;
